import type { SiteId } from "~/hec/utils/site-id";

/**
 * Marketing copy in the balance-details modal. Lived inline on the header mount
 * until the account card needed the same string (COM-17).
 */
export const DEFAULT_BALANCE_POPUP_TEXT =
  "All of your accounts are now in one place with BalanceDisplay™. The easier way to keep track of your balances and end of year purchases.";

/**
 * Sites where a TPA balance can exist. No `TPAConfig` entry's `supportedSites`
 * names WDH, so WDH always resolves `{TPA:""}` — gate off the fetch up front.
 */
export const HAS_TPA_BALANCE_BY_SITE: Record<SiteId, boolean> = {
  FSASTORE: true,
  HSASTORE: true,
  WDH: false,
};
